/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum for available heat pump equipment options.
 *
 * These are just used for the UI to display the correct options for heat pump equipment. All heat pumps are still stored as JobServiceEquipment.heat_pump in the database.
 */
export enum HeatPumpEquipmentOptions {
  ALL_ELECTRIC_HEAT_PUMP = 'all_electric_heat_pump',
  DUAL_FUEL_HEAT_PUMP_WITH_NEW_FURNACE = 'dual_fuel_heat_pump_with_new_furnace',
  DUAL_FUEL_HEAT_PUMP_WITH_EXISTING_FURNACE = 'dual_fuel_heat_pump_with_existing_furnace',
}
